import { createContext, useState, useEffect, useMemo } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        // Cargar usuario desde localStorage al iniciar
        const savedUser = localStorage.getItem("user");
        return savedUser ? JSON.parse(savedUser) : null;
    });
    const [workshops, setWorkshops] = useState(() => {
        // Cargar talleres desde localStorage al iniciar
        const savedWorkshops = localStorage.getItem("workshops");
        return savedWorkshops ? JSON.parse(savedWorkshops) : [];
    });
    const [selectedWorkshop, setSelectedWorkshop] = useState(() => {
        // Cargar el taller seleccionado desde localStorage al iniciar
        const savedSelectedWorkshop = localStorage.getItem("selectedWorkshop");
        return savedSelectedWorkshop ? JSON.parse(savedSelectedWorkshop) : null;
    });

    const [activeOrdersCount, setActiveOrdersCount] = useState(0);

    // Guardar usuario en localStorage cada vez que cambie
    useEffect(() => {
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        } else {
            localStorage.removeItem("user");
        }
    }, [user]);

    // Guardar talleres en localStorage cada vez que cambien
    useEffect(() => {
        localStorage.setItem("workshops", JSON.stringify(workshops));
    }, [workshops]);

    // Guardar el taller seleccionado en localStorage cada vez que cambie
    useEffect(() => {
        localStorage.setItem("selectedWorkshop", JSON.stringify(selectedWorkshop));
    }, [selectedWorkshop]);

    //  Memoizar el valor del context para evitar re-renders innecesarios
    const value = useMemo(() => ({
        user,
        setUser,
        workshops,
        setWorkshops,
        selectedWorkshop,
        setSelectedWorkshop,
        activeOrdersCount,
        setActiveOrdersCount,
    }), [user, workshops, selectedWorkshop, activeOrdersCount]);

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};